import { getLegCrewTitle } from '@lp/features/CaseOverview/components/Tabs/AssignedResources/utils';
import { RouteLegTypeEnum } from '@/api/apis/route';
import { useDriveTripQuery } from '@/queries/drive-service';
import { getFullName } from '@/utils/helpers';
import { CrewMemberGroundCard } from './CrewMemberGroundCard';

type GroundTripDriverCardProps = {
  tripId: string;
  legType: RouteLegTypeEnum.TmdxDriveAffiliateGroundLeg | RouteLegTypeEnum.TmdxDriveTedsGroundLeg;
};

export const GroundTripDriverCard = ({ tripId, legType }: GroundTripDriverCardProps) => {
  const { data, isLoading } = useDriveTripQuery(tripId);

  const hasData = Boolean(data?.vehicle || data?.driver?.driver);

  if (!data || !hasData || isLoading) return null;

  return (
    <div className="flex flex-col gap-3">
      {!!data.vehicle?.licensePlateNumber && (
        <span className="text-m-sb text-base-5">{data.vehicle?.licensePlateNumber}</span>
      )}
      {!!data.driver?.driver && (
        <CrewMemberGroundCard
          title={getFullName(data.driver.driver.firstName, data.driver.driver.lastName)}
          subTitle={getLegCrewTitle(legType)}
          imagePath={data.driver.driver.imagePath || ''}
        />
      )}
    </div>
  );
};
